<template>
  <VuePerfectScrollbar class="bb-table-wrapper bb-table-scroll"
                       :style="{minWidth: minWidth + 'px'}"
                       @ps-scroll-x="updateScroll"
                       ref="bbTableScroll"
                       :class="{
                         'bb-table-wrapper_auto-height': autoHeight,
                         'bb-table-wrapper_no-scroll': (!tableScroll || rows.length < 5 || hideScroll) && !autoHeight,
                         'bb-table-wrapper_modal': modalMode
                       }">
    <div class="bb-table-wrapper__item">
      <table class="bb-table bb-table_modal"
             :style="{minWidth: minWidth + 'px'}"
             :class="{
               'bb-table_modal': modalMode,
               'bb-table_layout-auto': noFixed
             }">
        <thead class="bb-table-header">
        <tr class="bb-table-header-row">
          <th class="bb-table-header__item bb-table-header__item_hide"/>
          <th class="bb-table-header__item"
              v-for="(column, colIndex) in columns"
              @click="clickThead(column)"
              :key="column.id"
              :class="{
            'bb-table-header__item_consumed-comments': column.property === 'consumedInvoice',
            'bb-table-header__item_log': column.isDescription,
            'bb-table-header__item_tax-checkbox': column.style === 'taxCheckbox',
            'bb-table-header__item_contact-finances': column.typeTable === 'contactFinances',
            'bb-table-header__item_contact-finances_tax': column.style === 'taxInvoice',
            'bb-table-header__item_number': column.property === 'consumedBalance',
            'bb-table-header__item_upload': column.upload,
            'bb-table-header__item_number': column.isNumber,
            'bb-table-header__item_credit-number': column.property === 'notesNumber',
            'bb-table-header__item_kpi-amount': column.typeTable === 'kpiInfo' && column.property === 'amount',
            'bb-table-header__item_no-padding': column.typeTable === 'kpiInfo' && column.padding,
            'bb-table-header__item_approval-toolbar': column.property === 'serviceIsApproved',
            'bb-table-header__item_approval-toolbar': column.property === 'approved',
            'bb-table-header__item_approval-toolbar': column.width === 'checkbox',
            'bb-table-header__item_credits': checkTableSticky(column) && !tableScroll,
            'bb-table-header__item_invoice-number': column.typeTable === 'kpiInfo' && column.property === 'number',
            'bb-table-header__item_pointer': column.sort,
            'bb-table-header__item_type-of-payment': column.property === 'typeOfPayment',
            'bb-table-header__item_consumed': column.property === 'consumed',
            'bb-table-header__item_percent': column.type === 'percent',
            'bb-table-header__item_service': column.class === 'service',
            'bb-table-header__item_date': column.type === 'date' && column.property !== 'approvedDate',
            'bb-table-header__item_date_with-time': column.style === 'dateWithTime',
            'bb-table-header__item_date_long': column.class === 'long-date',
            'bb-table-header__item_date_consumed': column.type === 'date' && column.typeTable === 'creditNotes',
            'bb-table-header__item_approval': column.type === 'icon',
            'bb-table-header__item_client-nickname': column.property === 'clientNickName',
            'bb-table-header__item_center': column.type === 'icon' || column.center,
            'bb-table-header__item_range': column.typeEditable === 'datePickerRange',
            'bb-table-header__item_description': column.property === 'paymentDescription',
            'bb-table-header__item_project': column.class === 'project',
            'bb-table-header__item_toolbar': column.toolbar,
            'bb-table-header__item_toolbar_credit-notes': column.toolbar && column.typeTable === 'creditNotes',
            'bb-table-header__item_toolbar-triple': checkTriple(column),
            'bb-table-header__item_toolbar_single': column.toolbarSingle,
            'bb-table-header__item_vip': column.property === 'vip',
            'bb-table-header__item_index': column.property === 'currentRow',
            'bb-table-body__item_input': column.editable,
            'bb-table-header__item_avatar-clients': column.type === 'img',
            'bb-table-header__item_avatars': column.class === 'avatars',
            'bb-table-header__item_bonus': column.bonusKPI || column.duplicateKPI
            }">
            <template v-if="column.sortByColumn">
            <span class="bb-table-header__item_select"
                  v-click-outside="hideFilter"
                  @mouseenter="stopHideFilter = false"
                  @mouseleave="hideFilter"
                  @click.stop="openFilterPopup = colIndex">
              {{ column.title }} <i class="icon-arrow-select"
                                    :class="{'icon-arrow-select_margin': column.property === 'soaStatus'}"></i>
             <transition name="fade-form">
                <FilterPopup class="bb-table-header-row-filter"
                             :list="column.list"
                             :direction="true"
                             :section="column"
                             @setData="setDataFilter"
                             v-if="openFilterPopup === colIndex"/>
             </transition>
            </span>
            </template>
            <template v-else-if="column.sort">
              <div class="bb-table-header__item_name">
                {{ column.title }}
                <i class="icon-arrow-sort bb-table-header__sort-icon"
                   :class="{'bb-table-header__sort-icon_active': filterByColumn === column.property}"/>
              </div>
            </template>
            <template v-else>
              {{ column.title }}
            </template>
          </th>
          <th class="bb-table-header__item bb-table-header__item_hide"
              :class="{'bb-table-header__item_without-toolbar': hideToolbar}"/>
        </tr>
        </thead>
        <draggable class="bb-table-body"
                   tag="tbody"
                   :forceFallback="true"
                   handle=".bb-table-body__handle"
                   ghostClass="bb-table-body-row_ghost-drag"
                   dragClass="bb-table-body-row_dragging"
                   chosenClass="bb-table-body-row_dragging"
                   v-if="rows && rows[0]"
                   :disabled="!rows.some(item => item.draggable)"
                   v-model="rows"
                   @change="dragChange"
                   @start="dragStart"
                   @end="dragEnd">
          <tr class="bb-table-body-row"
              ref="row"
              v-for="(row, index) in rows"
              :key="row.id || index"
              :data-id="row.id"
              :class="{
          'shake': wrongFormat === index,
          'bb-table-body-row__highlight': row.$highlight,
          'bb-table-body-row__total': row.name === 'Total',
          'bb-table-body-row_active': rowActive === index && !dragging && !row.static
          }"
              @click.stop="hideEditable(index)"
              @mouseenter="showRowActive(index)"
              @mouseleave="hideRowActive()">
            <td>
              <div class="bb-table-body-row__after bb-table-body-row__after_table"
                   :ref="'bbRowAfter' + index"/>
              <div class="bb-table-wrapper-drop-file"
                   v-if="dropFile && editTable===index && !statusUpload"
                   :style="{width: widthTable + 'px'}">
                <div class="bb-table-wrapper-drop-file__background"></div>
                <div class="bb-table-wrapper-drop-file-title">
                  <i class="icon-document bb-table-wrapper-drop-file-title__icon"/>
                  <span class="bb-table-wrapper-drop-file-title__text">Drop file here</span>
                  <template v-if="multiple">
                    <input class="bb-table-wrapper-drop-file-title__input"
                           type="file"
                           multiple
                           @change="previewFiles"
                           accept="application/pdf">
                  </template>
                  <template v-else>
                    <input class="bb-table-wrapper-drop-file-title__input"
                           type="file"
                           @change="previewFiles"
                           accept="application/pdf">
                  </template>
                </div>
              </div>
            </td>
            <td class="bb-table-body__item"
                v-for="(column, columnIndex) in columns"
                :key="column.id"
                @click.stop="clickCell(row, column, index)"
                :class="{
            'bb-table-body__item_kpi-info': column.typeTable === 'kpiInfo',
            'bb-table-body__item_consumed-comments': column.property === 'consumedInvoice',
            'bb-table-body__item_contact-finances': column.typeTable === 'contactFinances',
            'bb-table-body__item_contact-finances_tax': column.style === 'taxInvoice',
            'bb-table-body__item_consumed': column.property === 'consumed',
            'bb-table-body__item_center': column.type === 'icon' || column.center,
            'bb-table-body__item_index': column.property === 'currentRow',
            'bb-table-body__item_capitalize': column.capitalize,
            'bb-table-body__item_pointer': checkRouting(row, column),
            'bb-table-body__item_vip': column.property === 'vip',
            'bb-table-body__item_input_active': column.editable && editTable === index,
            'bb-table-body__item_input_active_checkbox': column.typeEditable === 'checkbox',
            'bb-table-body__item_input': column.editable,
            'bb-table-body__item_avatar': column.type === 'img',
            'bb-table-body__item_avatar-client': column.type === 'img' && column.style === 'clientBalance',
            'bb-table-body__item_avatars': column.class === 'avatars',
            'bb-table-body__item__copied': column.type === 'copiedValue'
            }">
              <transition name="bounce">
                <div class="bb-table-body__handle"
                     v-if="rows.some(item => item.draggable) && rowActive === index && columnIndex === 0">
                  <i class="icon-drag_ia"/>
                </div>
              </transition>
              <template v-if="column.upload">
                <div class="bb-table-body-upload"
                     :class="{
                       'bb-table-body-upload_tax': column.style === 'taxInvoiceFile'
                     }">
                  <transition name="fade">
                    <Upload class="bb-table-body-upload__icon"
                            v-if="editTable === index || (row.uploadFile && row.uploadFile.length > 0)"
                            :multiple="multiple"
                            :icon-view="column.icon"
                            :popupDown="index !== rows.length -1"
                            :files="row.uploadFile"
                            :view="row.uploadFile && row.uploadFile.length > 0"
                            :upload="editTable === index"
                            :index="columnIndex"
                            :item="{row, column}"
                            @statusUpload="setDisabledSave"
                            @view="getFile"
                            @delete="deleteFile"
                            @upload="uploadFile"/>
                  </transition>
                </div>
              </template>
              <div class="bb-table-body__toolbar" v-if="column.property === 'action'">
                <div class="bb-table-body-upload"
                     v-if="uploadDisplay(row, column, index)">
                  <Upload class="bb-table-body-upload__icon"
                          :multiple="multiple"
                          :popupDown="index !== rows.length -1"
                          :files="row.uploadFile"
                          :view="row.uploadFile && row.uploadFile.length > 0"
                          :upload="editTable === index"
                          :item="{row, column}"
                          @statusUpload="setDisabledSave"
                          @view="getFile"
                          @delete="deleteFile"
                          @upload="uploadFile"/>
                </div>
                <transition name="fade-form">
                  <div v-if="actionsDisplay(row, column, index)">
                    <Toolbar v-if="toolbarDisplay(row, column, index)"
                             :delete-index="deleteConfirmIndex"
                             :index="index"
                             :item="row"
                             :type="column.typeTable"
                             :top="index === rows.length - 1"
                             :btn-add="checkButton('add', column, row)"
                             :no-edit="checkButton('edit', column, row)"
                             :no-delete="checkButton('delete', column, row)"
                             @deleteOpen="deleteConfirmIndex = index"
                             @deleteClose="deleteConfirmIndex = false"
                             @btnAdd="openSettings(index, row, column)"
                             @openEdit="openEdit(index, row, column)"
                             @deleteItem="delItem(column, row, index)"/>
                  </div>
                </transition>
                <template v-if="column.property === 'action' && editTable === index">
                  <div class="bb-table-body-upload bb-table-body-upload_button"
                       :class="{'bb-table-body-upload_button_kpi-info': column.typeTable === 'kpiInfo'}">
                    <button class="bb-button bb-table-body__button"
                            :disabled="disableSave"
                            :class="{'bb-table-body-upload__button': column.toolbar.upload}"
                            @click.stop="editItem(row, column, index)">
                      {{ newRow ? 'ADD' : 'SAVE' }}
                    </button>
                  </div>
                </template>
              </div>
              <template v-if="getEditable(column, row) && editTable === index && !row.onlyApprove">
                <template v-if="column.typeEditable === 'datePicker'">
                  <DataPicker @setDate="setDate"
                              font-size="14"
                              :current-month="column.typeTable === 'kpiInfo'"
                              :default-date="getProp(row, column, true)"
                              :obj="{row: row, column: column}"/>
                </template>
                <template v-else-if="column.typeEditable === 'datePickerRange'">
                  <DataPicker @setDate="setDate"
                              font-size="14"
                              :range="'range'"
                              :default-date="getProp(row, column, true)"
                              :obj="{row: row, column: column}"/>
                </template>
                <template v-else-if="column.typeEditable === 'array'">
                  <ConsumedInvoice :comments="getConsumedList(row, column)"
                                   @setDisabledUpdate="setDisabledSave"
                                   :row="row"
                                   :index="index"
                                   :copyRows="copyRows"
                                   :column="column"
                                   :disabled="false"
                                   :disabledAdd="disableSave"
                                   @update="updateComments"/>
                </template>
                <template v-else-if="column.typeEditable === 'select'">
                  <div class="bb-table-body-select"
                       v-if="column.list.length > 0">
                    <custom-select
                      :min-width="true"
                      :table-mode="tableScroll"
                      :fixed="true"
                      :list="column.list"
                      :item="{row, column}"
                      @setValue="setSelect"
                      :default-val="getProp(row, column, true)"/>
                  </div>
                </template>
                <template v-else-if="column.typeEditable === 'checkbox'">
                  <div class="bb-table-body__item__flex-item"
                       :class="{'bb-table-body__item__icons': column.typeTable === 'kpiInfo'}">
                    <checkbox :name="row"
                              :animation="column.typeEditable === 'checkbox'"
                              :section="column"
                              :value="getProp(row, column).bonusKPI"
                              @checkboxChange="checkboxChange"/>
                    <span class="bb-table-body__item__approved-icon_double"
                          v-if="row.$doubleKpi">x2</span>
                  </div>
                </template>
                <template v-else-if="column.typeEditable && checkVisibleStatus(row, column)">
                  <div class="bb-table-wrapper-input"
                       :class="{'bb-table-body__input_min-width': column.showComment}"
                  >
                    <input class="bb-input bb-input_border bb-table-body__input bb-table-body__input_bank"
                           :class="{
               'bb-input_error' : error,
               'bb-table-body__input_width': column.property === 'paymentDescription' || column.style === 'long-input'}"
                           v-if="row.noEdit ? !row.noEdit[column.property] : true"
                           @keyup.esc="hideEditable()"
                           @keyup.enter="editItem(row, column, index)"
                           @input="checkedInput(row, column, index)"
                           v-autofocus="checkPropertyFocus(column)"
                           @focus="focusInput(row, column, index)"
                           :placeholder="column.placeholder || ''"
                           v-model="copyRows[index][column.property]">
                    <transition name="fade">
                      <span class="bb-table-wrapper-input__error" v-if="error">{{ error }}</span>
                    </transition>
                  </div>
                </template>
              </template>
              <template
                v-else-if="column.typeEditable === 'checkbox' && column.typeTable === 'kpiInfo' && !row.static">
                <div class="bb-table-body__item__icons">
                  <img src="@/assets/images/icon-pencil.png"
                       class="bb-table-body__item__approved-icon"
                       @click.stop="openEdit(index, row, column)"/>
                  <span class="bb-table-body__item__approved-icon bb-table-body__item__approved-icon_double"
                        v-if="row.isBonusBC"
                        @click.stop="openEdit(index, row, column, true)">x2</span>
                </div>
              </template>
              <template v-else-if="column.viewMode === 'checkbox'">
                <div class="bb-table-body__item__flex-item">
                  <checkbox :name="row"
                            :animation="column.typeEditable === 'checkbox'"
                            :section="column"
                            :disabled="editTable !== index || (editTable !== index && !row.onlyApprove)"
                            @checkboxChange="checkboxChange"
                            :value="getProp(row, column)"/>
                </div>
              </template>
              <template v-else-if="column.type === 'copiedValue'">
                <div class="bb-table-body__item__flex-item bb-table-body__item-copyCell">
                  {{ getProp(row, column) }}
                  <span
                    v-if="rowActive === index"
                    class="bb-table-body__item-copy-icon"
                    @click="copyToClipboard(getProp(row, column))"
                  >
                     <img
                       :src="require('@/assets/images/icon-copy.png')"
                       alt="copy"
                     >
                  </span>
                </div>
              </template>
              <template v-else-if="column.type === 'img'">
                <div :class="{'bb-table-wrapper-img': column.popup}">
                  <img :src="getProp(row, column) || column.defaultImg"
                       @mouseleave="restPopupPosition($event, index, column.id)"
                       @mouseenter="setPopupPosition($event, index, column.id)"/>
                  <span class="bb-table-wrapper-img__popup"
                        v-if="getPopupValue(row,column)"
                        :ref="'bbPopupImg' + index + column.id"
                        :style="{
                          left: getPopupPosition('bbPopupImg' + index + column.id, 'left'),
                          top: getPopupPosition('bbPopupImg' + index + column.id, 'top'),
                          position: getPopupPosition('bbPopupImg' + index + column.id, 'position')
                        }">
                    {{ getPopupValue(row, column) }}
                  </span>
                </div>
              </template>
              <template v-else-if="column.type === 'icon'">
                <i :class="getProp(row, column)" class="bb-table-body__item_icon-check-mark"/>
              </template>
              <template v-else-if="column.type === 'link'">
                <LinkOnProforma :column="column"
                                :index="index"
                                :items="row.creditNotesSoaRefund"
                                @openProforma="openProforma"
                                :row="row"/>
              </template>
              <template v-else-if="column.typeEditable === 'select'">
                {{ getProp(row, column) }}
              </template>
              <template v-else-if="column.typeEditable === 'array'">
                <ConsumedInvoice :comments="getConsumedList(row, column)"
                                 :disabled="true"
                                 :index="index"
                                 :row="row"
                                 :copyRows="copyRows"
                                 :column="column"/>
              </template>
              <template v-else-if="column.type === 'toggle'">
                <toggle @toggleChange="toggleChange"
                        :name="{row, column}"
                        :disabled="column.typeTable === 'creditNotes'"
                        :confirm="toggleConfirm === index + 1"
                        type="accent"
                        :value="getProp(row, column)"/>
              </template>
              <template v-else-if="column.property === 'soaStatus'">
                <div class="bb-table-body-row__status
                            bb-table-body-row__status_cursor"
                     :class="'bb-table-body-row__status_' + getProp(row, column)"
                />
              </template>
              <template v-else-if="column.property === 'vip'">
                <i class="icon-crown" v-if="getProp(row, column)"/>
              </template>
              <template v-else-if="column.property === 'currentRow'">
                <div class="bb-table-body__index"
                     :class="{'bb-table-body__index_active': activeRow === index}">
                  {{ index + 1 }}
                </div>
              </template>
              <template v-else-if="column.statusNumber">
                <span class="bb-table-body__item_received"
                      :class="'bb-table-body__item_received_' + getProp(row, column).status">
              {{ getProp(row, column).value }}
            </span>
              </template>
              <div class="bb-table-body__container"
                v-else-if="column.bonusKPI || column.duplicateKPI || column.commentApproval">
                <div class="bb-table-body__item__flex-item_mark"
                     v-if="getProp(row, column).duplicateKPI"
                >
                  DUP
                </div>
                <span class="bb-table-body__item__approved-icon
                             bb-table-body__item__approved-icon_cursor
                             bb-table-body__item__approved-icon_double"
                      v-else-if="getProp(row, column).bonusKPI"
                >
                  x2
                </span>
                <div class="bb-table-body__item__approved-icon
                            bb-table-body__item__approved-icon_cursor"
                     v-if="getProp(row, column).commentApproval"
                >
                  <i class="icon-info bb-table-body__user-info bb-table-body__user-info_static"
                     ref="iconPopup"
                     @mouseenter="setPositionPopup($event, row._id)"
                     @mouseleave="showPopup = false"
                  />
                  <transition name="bounce">
                    <Popup v-if="showPopup === row._id"
                           :style="popupPosition"
                           :radio="false"
                           :content="getProp(row, column).commentApproval"
                    />
                  </transition>
                </div>
              </div>
              <template v-else-if="column.dependence">
                <span v-if="column.statusDependence"
                  class="bb-table-body__item_received"
                  :class="column.hideHighlight ? '' : 'bb-table-body__item_received_' + getProp(row, column).status">
              {{ getProp(row, column).status }}
            </span>
                <span v-else-if="column.statusBackground"
                      class="bb-table-body__item_received"
                      :class="'bb-table-body__item_received_' + getProp(row, column).status">
              {{ getProp(row, column).value }}
            </span>
                <span v-else-if="column.statusBackground"
                      class="bb-table-body__item_received"
                      :class="'bb-table-body__item_received_' + getProp(row, column).status">
              {{ getProp(row, column).value }}
            </span>
                <div v-else>{{ getProp(row, column).value }}</div>
              </template>
              <template v-else-if="column.type === 'percent'">
                {{ getProp(row, column) }}%
              </template>
              <template v-else-if="getColumnHover(column, row)">
                <div class="bb-table-body__with-hover"
                     :class="{'bb-table-body__with-hover_null': getProp(row, column) === '0.00'}">
                  {{ getProp(row, column) }}
                </div>
              </template>
              <template v-else-if="column.typeTable === 'kpiTable' && column.property === 'username'">
              <span class="bb-table-body__relative">
                {{ getProp(row, column) }}
                <i class="icon-info bb-table-body__user-info"
                   @mouseleave="hideInfo(row, column)"
                   @mouseenter="displayInfo(row, column, $event)"/>
              </span>
              </template>
              <template v-else-if="logTableDetails(row, column)">
                <i
                  class="icon-info bb-table-wrapper-info__icon"
                  @mouseenter="onMouseenter(row, column, $event)"
                  @mouseleave="showPopupLogHistory = false"
                />
              </template>
              <template v-else>
                <div :class="{
                       'bb-table-wrapper-info': column.info || row.$info,
                       'bb-table-wrapper-info_logs': row.$info
                }">
                  <div v-html="getProp(row, column)">{{ getProp(row, column) }}</div>
                  <span v-if="(column.info && getInfo(row, column)) || (column.possibleInfo && getInfoRow(row))"
                        class="bb-table-wrapper-info__icon-wrapper">
                  <i class="icon-info bb-table-wrapper-info__icon"
                     @mouseleave="showInfo = false"
                     @mouseenter="showInfo = row.id"/>
                    <transition name="bounce">
                      <div class="bb-table-header-popup bb-table-wrapper-info__popup"
                           :class="{
                             'bb-table-wrapper-info__popup_logs': row.$info,
                             'bb-table-header-popup_bottom': row.$info
                           }"
                           v-if="showInfo === row.id">
                        <span class="bb-table-header-popup__title" v-if="column.infoTitle">
                          {{ column.infoTitle }}
                        </span>
                        {{ getInfoRow(row) || convertNumber(getInfo(row, column)) }}
                      </div>
                    </transition>
                </span>
                </div>
              </template>
            </td>
          </tr>
        </draggable>
      </table>
      <div v-if="noDataText && (!rows || !rows[0])">
        <TableNoData :explanation="noDataText" :border="true"/>
      </div>
      <transition name="fade">
        <PopupLogHistory
          v-if="showPopupLogHistory"
          :details="details"
          :popupPosition="popupPosition"
        />
      </transition>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import _ from 'lodash'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import toggle from '@/components/Main/Inputs/toggle'
import checkbox from '@/components/Main/Inputs/checkbox'
import ConvertNumber from '@/mixin/convertNumber'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import LinkOnProforma from '@/components/Main/Table/LinkOnProforma/LinkOnProforma'
import Upload from '@/components/Main/Upload/Upload'
import moment from 'moment'
import draggable from 'vuedraggable'
import Popup from '@/components/Main/Popup/Popup'
import FilterPopup from '@/components/Main/FilterPopup/FilterPopup'
import {statusInvoiceList} from '@/constants/statusInvoiceList'
import ConsumedInvoice from '@/components/Main/Table/ConsumedInvoice/ConsumedInvoice'
import TableNoData from '@/components/Main/Table/TableNoData/TableNoData'
import preventBackOnHorizontalScroll from '@/mixin/preventBackOnHorizontalScroll'
import removeAllEventListener from '@/mixin/removeAllEventListener'
import {
  CLIENT_HISTORY,
  CLIENT_COMPANY_HISTORY
} from '@/constants/logTypes'
import PopupLogHistory from '@/components/Main/PopupLogHistory/PopupLogHistory'

export default {
  name: 'Table',
  props: [
    'options',
    'modalMode',
    'minHeight',
    'totalPages',
    'hideScroll',
    'multiple',
    'autoHeight',
    'hideToolbar',
    'noDataText',
    'noFixed',
    'heightTable',
    'minWidth',
    'stopScrollUp'
  ],
  mixins: [ConvertNumber, preventBackOnHorizontalScroll, removeAllEventListener],
  components: {
    PopupLogHistory,
    ConsumedInvoice,
    Toolbar,
    toggle,
    DataPicker,
    CustomSelect,
    Upload,
    LinkOnProforma,
    VuePerfectScrollbar,
    checkbox,
    draggable,
    Popup,
    FilterPopup,
    TableNoData,
  },
  data () {
    return {
      showInfo: false,
      popupPosition: {},
      disableSave: false,
      dragging: false,
      toggleConfirm: false,
      statusUpload: false,
      editTable: false,
      newRow: false,
      rowActive: false,
      deleteConfirmIndex: false,
      copyRows: {},
      showPopup: false,
      dropFile: false,
      wrongFormat: false,
      activeRow: false,
      tableScroll: false,
      openFilterPopup: false,
      stopHideFilter: false,
      filterByColumn: false,
      widthTable: 0,
      scrollX: 0,
      error: false,
      leave: ['dragleave', 'drop'],
      enter: ['dragenter', 'dragover'],
      details: [],
      showPopupLogHistory: false
    }
  },
  computed: {
    mainScroll: {
      get () {
        return this.$store.getters.mainScroll
      },
      set (data) {
        this.$store.dispatch('setMainScroll', data)
      }
    },
    columns: {
      get () {
        return this.$store.getters[this.options.columns.getColumnsData]
      },
      set (data) {
        this.$store.dispatch(this.options.columns.setColumnsData, data)
      }
    },
    rows: {
      get () {
        return this.$store.getters[this.options.rows.getRowsData]
      },
      set (data) {
        this.$store.dispatch(this.options.rows.setRowsData, data)
      }
    },
    calcHeight () {
      return _.debounce(this.calcHeightTable, 250)
    }
  },
  methods: {
    logTableDetails (row, column) {
      const { typeTable, property } = column
      const { transactionTypeId } = row
      return typeTable === 'logTable' &&
        property === 'details' &&
        (transactionTypeId === CLIENT_HISTORY.id || transactionTypeId === CLIENT_COMPANY_HISTORY.id)
    },
    onMouseenter (row, column, { target }) {
      const {top, left} = target.getBoundingClientRect()
      this.popupPosition = {
        top: `${top + 20}px`,
        left: `${left}px`
      }
      const { property } = column
      const details = _.get(row, property, '')
      this.details = JSON.parse(details)
      this.showPopupLogHistory = !this.showPopupLogHistory
    },
    checkTableSticky (column) {
      return column.typeTable === 'creditNotes' || column.typeTable === 'vatDocs'
    },
    hideInfo (row, column) {
      const hide = _.get(column, 'openModal.hide', '')
      if (hide) hide(row, column)
    },
    displayInfo (row, column, e) {
      const display = _.get(column, 'openModal.display', '')
      if (display) display(row, column, e)
    },
    previewFiles (event) {
      this.fileData.set('files', event.target.files)
    },
    uploadFile (files, item) {
      const id = _.get(item, 'row.id', '')
      const newMode = _.get(item, 'row.newMode', '')
      const params = newMode ? {newMode: true} : {id: id}
      const index = _.findIndex(this.copyRows, params)
      const copyRow = this.copyRows[index]
      const upload = _.get(item, 'column.actions.uploadFile', '')
      this.statusUpload = true
      if (upload) {
        upload(files, item.row, this.rows, copyRow)
        this.disableSave = true
      } else {
        console.error('is absent column.actions.uploadFile')
      }
      if (item.row) {
        let uploadedFiles = _.get(item, 'row.uploadFile', [])
        _.forEach(files, file => {
          file.label = file.name
          Array.isArray(uploadedFiles) ? uploadedFiles.push(file) : uploadedFiles = file
        })
        item.row.uploadFile = uploadedFiles
      }
    },
    setDisabledSave (val) {
      this.disableSave = val
    },
    deleteFile (fileId, {row, column}) {
      if (fileId && column) {
        const id = _.get(row, 'id', '')
        const newMode = _.get(row, 'newMode', '')
        const params = newMode ? {newMode: true} : {id: id}
        const index = _.findIndex(this.copyRows, params)
        const copyRow = this.copyRows[index]
        column.actions.deleteFile(fileId, row, this.rows, copyRow)
      }
      const index = _.findIndex(row.uploadFile, {id: fileId})
      if (index !== -1) row.uploadFile.splice(index, 1)
      const copyRow = _.find(this.copyRows, {id: row.id})
      if (copyRow && index !== -1) {
        copyRow.uploadFile.splice(index, 1)
      }
      this.statusUpload = false
    },
    getFile (file, {row, column}) {
      if (file && column) {
        column.actions.getFile(file)
      }
      this.statusUpload = false
    },
    setSelect (item, obj) {
      const row = obj.row
      const column = obj.column
      let index = _.findIndex(this.copyRows, {id: row.id})
      if (row.newMode) {
        index = _.findIndex(this.copyRows, 'newMode')
      }
      if (column.propertyWrite) {
        _.set(this.copyRows[index], column.propertyWrite, item.id)
        _.set(this.copyRows[index], 'origin' + column.propertyWrite, item)
      } else {
        _.set(this.copyRows[index], column.property, item.id)
        _.set(this.copyRows[index], 'origin' + column.property, item)
      }
    },
    updateComments (row, column, array) {
      const result = _.cloneDeep(array).map(item => {
        item.consumedAmount = Number(item.consumedAmount)
        if (item.uploadFile && item.uploadFile.length === 0) {
          delete item.uploadFile
        }
        return item
      })
      const params = row.newMode ? 'newMode' : {id: row.id}
      const index = _.findIndex(this.copyRows, params)
      _.set(this.copyRows[index], column.property, result)
    },
    formatDate (date, column) {
      if (_.isNull(date)) return ''
      const momentDate = moment(new Date(date))
      if (!momentDate.isValid()) {
        return date === 'Invalid date' ? '' : date
      }
      const format = _.get(column, 'formatDate', 'DD-MMM-YY')
      return momentDate.format(format)
    },
    checkPropertyFocus (column) {
      const condition = ['partnerName', 'debit', 'credit', 'notesNumber', 'consumedInvoice', 'paymentDescription']
      let result = false
      const payroll = column.property === 'amountAED' && column.typeTable === 'payroll'
      condition.forEach((item) => {
        if (column.property === item) {
          result = true
        }
      })
      return result || payroll
    },
    focusInput (row, column, index) {
      this.error = ''
      if (column.typeEditable === 'inputNumber') {
        const number = this.validateNum(this.getProp(this.copyRows[index], column))
        this.copyRows[index][column.property] = number === 0 ? '' : number
      }
    },
    validateNum (number) {
      if (typeof number === 'string') {
        number = number.replace(/[^.\d;]/g, '')
      }
      if (isNaN(number)) {
        return 0
      } else {
        return +number
      }
    },
    getStatusPaid (row, total, received) {
      const status = _.get(row, 'status', 0)
      const invoiceStatus = statusInvoiceList.find(item => item.id === status) || statusInvoiceList[0]
      const difference = received - total
      if (invoiceStatus.id === 0) {
        return {
          value: this.convertNumber(0),
          status: invoiceStatus.name
        }
      }
      if (invoiceStatus.id === 2) {
        return {
          value: this.convertNumber(0),
          status: invoiceStatus.name
        }
      } else if (invoiceStatus.id === 3) {
        return {
          value: this.convertNumber(difference),
          status: invoiceStatus.name
        }
      } else if (invoiceStatus.id === 1) {
        return {
          value: this.convertNumber(difference * -1),
          status: invoiceStatus.name
        }
      }
    },
    roundNum (num) {
      return Math.round(num * 100) / 100
    },
    checkboxChange (data, row, column) {
      const idProps = row._id ? {_id: row._id} : {id: row.id}
      const findParams = row.newMode ? 'newMode' : idProps
      const index = _.findIndex(this.copyRows, findParams)
      _.set(this.copyRows[index], column.property, data)
    },
    getConsumedList (row, column) {
      return _.get(row, column.property, [])
    },
    getPopupPosition (key, val) {
      return _.get(this.popupPosition, [key, val], '')
    },
    setPositionPopup (e, rowId) {
      this.showPopup = rowId
      const popups = _.get(this.$refs, 'iconPopup', '')
      const popupWidth = _.get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      this.popupPosition = {
        position: 'fixed',
        left: (box.left - diffLeft + 5) + 'px',
        top: box.top + 30 + 'px'
      }
    },
    setPopupPosition (e, index, col) {
      const key = 'bbPopupImg' + index + col
      const popups = _.get(this.$refs, key, '')
      const popupWidth = _.get(popups[0], 'offsetWidth', 0)
      const diffLeft = popupWidth / 2
      const box = e.target.getBoundingClientRect()
      const position = {
        position: 'fixed',
        left: (box.left - diffLeft + 15) + 'px',
        top: box.top + 'px'
      }
      this.$set(this.popupPosition, key, position)
      if (popups[0]) {
        this.$nextTick(() => {
          popups[0].style.opacity = 1
        })
      }
    },
    restPopupPosition (e, index, col) {
      const key = 'bbPopupImg' + index + col
      const popups = _.get(this.$refs, key, '')
      const popup = _.get(popups, 0, 0)
      if (popup) {
        popup.style.opacity = 0
      }
    },
    getPopupValue (row, column) {
      return _.get(row, column.popup, '')
    },
    getInfo (row, column) {
      return _.get(row, column.info, '')
    },
    getInfoRow (row) {
      return _.get(row, '$info', '')
    },
    getEditable ({editable}, row) {
      if (typeof editable === 'boolean') {
        return editable
      }
      return _.get(row, editable, false)
    },
    getColumnHover ({hover}, row) {
      if (!hover) return false
      if (typeof hover === 'boolean') {
        return hover
      }
      return !_.get(row, hover, false)
    },
    getProp (row, column, full) {
      const defaultValue = _.get(row, column.defaultProperty, '')
      let value = _.get(row, column.property, defaultValue)
      if (column.noNull && !value) {
        return ''
      }
      if (column.duplicateKPI) {
        return {
          duplicateKPI: _.get(row, column.propertyAlt, ''),
          commentApproval: _.get(row, column.propertyApp, ''),
          bonusKPI: value
        }
      }
      if (!value && column.calc) {
        const sum = _.reduce(column.calc, (sum, item, index) => {
          const num = _.get(row, index, 0)
          if (item === '+') {
            return sum + num
          } else {
            return sum - num
          }
        }, 0)
        return this.convertNumber(sum)
      }
      if (column.property === 'soaStatus') {
        const isSoaProforma = _.get(row, 'isSoaProforma', false)
        if (isSoaProforma) return 'none'
        const status = (value === 1) ? 'open' : (value === 2) ? 'completed' : (value === 3) ? 'consumed' : 'none'
        return status
      }
      if (column.percent) {
        const number = _.get(row, column.percent.number, '')
        const target = _.get(row, column.percent.of, '')
        const division = number / target
        const notNumber = _.isNaN(division) || Infinity === division || -Infinity === division
        return notNumber ? '' : this.roundNum(division * 100) + '%'
      }
      if (column.statusNumber) {
        const condition = column.statusRevert ? value < 0 : value > 0
        return {
          value: this.convertNumber(Math.abs(value)),
          status: condition ? 'overpaid' : 'underpaid'
        }
      }
      if (column.dependence) {
        const total = _.get(row, column.dependence, '')
        return this.getStatusPaid(row, total, value)
      }
      if (column.typeEditable === 'datePickerRange' && !full) {
        const start = moment(new Date(value.start)).format('DD-MMM-YY')
        const end = moment(new Date(value.end)).format('DD-MMM-YY')
        if (moment(new Date(value.start)).isValid() && moment(new Date(value.end)).isValid()) {
          return start + ' - ' + end
        }
        return ''
      }
      if (column.type === 'date' && column.typeEditable !== 'datePickerRange' && !row.dateParse && !full) {
        return this.formatDate(value, column)
      }
      if (typeof value === 'number' && column.type !== 'percent') {
        return this.convertNumber(value)
      }
      if (column.typeEditable === 'select' && !value && this.rows[this.editTable] === row) {
        return column.placeholder || ''
      }
      if (column.typeEditable === 'select' && value && !full) {
        const result = value.name ? value.name : value
        return column.type === 'percent' ? result + '%' : result
      }
      if (column.type === 'icon') {
        return value ? column.icon : ''
      }
      if (column.visible) {
        return this.checkVisibleStatus(row, column) ? value : ''
      }
      return value
    },
    uploadDisplay (row, column, index) {
      if (column.typeTable === 'creditNotes') return false
      const hasToolbar = column.toolbar && column.toolbar.upload
      const hasUpload = row.uploadFile ? row.uploadFile.length > 0 : false
      const editRow = this.editTable === index
      return hasToolbar && (hasUpload || editRow)
    },
    actionsDisplay (row, column, index) {
      const activeRow = this.rowActive === index
      const total = row.name === 'Total'
      const partnersPayouts = row.name === 'Partner payouts'
      const visible = _.get(row, column.visible, '')
      return (activeRow && !partnersPayouts && !total) || visible
    },
    openProforma (item) {
      this.$emit('openProforma', item)
    },
    toolbarDisplay (row, column, index) {
      const kpiTable = column.typeTable === 'kpiInfo' || column.typeTable === 'kpi'
      const editRow = this.editTable !== index
      if (column.visible && column.toolbar && !row.static) return true
      return column.property === 'action' && (kpiTable || editRow) && !row.static
    },
    checkButton (type, column, row, index) {
      if (type === 'edit') {
        const columnHide = column.toolbar.hideEditBtn ? column.toolbar.hideEditBtn : false
        const rowHide = row.noButton ? row.noButton.edit : false
        const kpi = column.typeTable === 'kpiInfo'
        const kpiAmount = column.typeTable === 'kpiInfo' && !row.amount
        return columnHide || rowHide || kpi || kpiAmount
      } else if (type === 'delete') {
        const approved = row.onlyApprove
        const columnHide = column.toolbar.hideDeleteBtn ? column.toolbar.hideDeleteBtn : false
        const rowHide = row.noButton ? row.noButton.delete : false
        return columnHide || rowHide || approved
      } else if (type === 'add') {
        const funds = column.typeTable === 'funds'
        const kpi = column.typeTable === 'kpiInfo' && this.editTable === index
        const hideBtn = _.get(column, 'toolbar.hideAddBtn', false)
        return !hideBtn && (funds || kpi)
      }
    },
    openSettings (index, row, column) {
      if (column.typeTable === 'funds') {
        column.actions.settings(this.copyRows[index])
      } else if (column.typeTable === 'kpiInfo') {
        this.editTable = false
        column.actions.save(this.copyRows[index])
      }
    },
    openEdit (index, row, column, double) {
      if (column.forceActions) {
        column.actions.edit(row)
        return
      } else if (column.typeTable === 'funds' || column.typeTable === 'kpi') {
        this.editItem(row, column, index)
        return
      } else if (column.typeTable === 'kpiInfo') {
        this.editTable = index
        _.set(this.copyRows[index], '$doubleKpi', double)
        _.set(row, '$doubleKpi', double)
        return
      }
      this.editTable = index
      this.statusUpload = false
      this.delNewRow()
    },
    toggleChange (data, item) {
      const row = item.row
      const column = item.column
      if (data === 'hide') {
        this.toggleConfirm = false
        return
      }
      const indexNewRow = _.findIndex(this.rows, {newMode: true})
      const index = _.findIndex(this.copyRows, {id: row.id})
      if (index !== -1) {
        _.set(this.copyRows[index], column.property, data)
        this.columns[0].actions.edit(this.copyRows[index])
      } else if (this.newRow && indexNewRow !== -1) {
        _.set(this.copyRows[indexNewRow], column.property, data)
        _.set(this.rows[indexNewRow], column.property, data)
      }
      if (column.property === 'consumed' && data && row && index !== -1) {
        this.openEdit(index, row, column)
      }
      this.toggleConfirm = false
    },
    checkedInput (row, column, index) {
      if (column.notMore) {
        this.checkedNoteMore(row, column, index)
      }
      this.error = ''
      if (column.onlyOne) {
        _.set(this.copyRows[index], column.onlyOne, 0)
      }
    },
    checkedNoteMore (row, column, index) {
      const number = this.validateNum(this.getProp(this.copyRows[index], column))
      const propertyValue = _.get(column, 'notMore', '')
      const amountValue = _.get(row, propertyValue, 0)
      if (number > amountValue) {
        _.set(this.copyRows[index], [column.property], amountValue)
      }
    },
    editItem (row, column, index) {
      const currentVal = +_.get(this.copyRows, [index, row.minValueWith], 0)
      if (row.minValue && row.minValueWith && currentVal < row.minValue) {
        this.error = 'min value: ' + row.minValue
        return
      }
      this.error = ''
      if (column.typeTable === 'kpiInfo') {
        this.openSettings(index, row, column)
        return
      }
      _.forEach(column.inputs, property => {
        this.copyRows[index][property] = this.validateNum(this.copyRows[index][property])
      })
      delete this.copyRows[index].balanceAED
      if (column.actions.edit && !this.newRow) {
        column.actions.edit(this.copyRows[index])
      } else if (this.newRow) {
        row.create(this.copyRows[index])
      }
      this.hideEditable()
    },
    delItem (column, item) {
      if (column.actions.delete) {
        column.actions.delete(item.id)
        this.deleteConfirmIndex = false
      }
    },
    delNewRow () {
      const index = _.findIndex(this.rows, {newMode: true})
      if (this.newRow && index > -1) {
        this.rows.splice(index, 1)
        this.newRow = false
      }
    },
    checkRouting (row, column) {
      const checkRouteProp = _.get(column, 'checkRoute', '')
      const checkRoute = _.get(row, checkRouteProp, false)
      if (checkRoute) return false
      const hasNameRoute = column.nameRoute && !column.settingsRoute
      if (column.route || column.action || hasNameRoute) return true
      if (column.settingsRoute) {
        const paramName = _.get(column, 'settingsRoute.nameParam', '')
        const paramProp = _.get(column, 'settingsRoute.valParam', '')
        const paramValue = _.get(row, paramProp, '')
        return paramName && paramProp && paramValue
      }
    },
    clickCell (row, column, index) {
      this.hideFilter()
      if (column.type !== 'toggle') {
        this.toggleConfirm = false
      } else {
        this.toggleConfirm = index + 1
      }
      if (column.route || column.nameRoute) {
        const clientID = _.get(row, column.route, '')
        const name = column.nameRoute || 'Soa'
        if (clientID) {
          return this.$router.push({name: name, params: {id: clientID, ...column.paramsRoute}})
        } else if (column.paramsRoute) {
          return this.$router.push({name: name, params: column.paramsRoute})
        } else if (column.settingsRoute) {
          const paramName = _.get(column, 'settingsRoute.nameParam', '')
          const paramProp = _.get(column, 'settingsRoute.valParam', '')
          const paramValue = _.get(row, paramProp, '')
          if (!paramName || !paramProp || !paramValue) return
          return this.$router.push({name: name, params: {[paramName]: paramValue}})
        } else if (name !== 'ContactCard') {
          return this.$router.push({name: name})
        }
      }
      if (column.clickAction) {
        if (row.clickStop && row.clickStop.includes(column.mark)) {
          return
        }
        this.activeRow = index
        column.clickAction(row, column)
      }
    },
    setWidthActiveRow () {
      this.widthTable = _.get(this.$refs, 'bbTableScroll.$el.offsetWidth', 0)
      _.forEach(this.rows, (item, index) => {
        const afterElement = _.get(this.$refs, `bbRowAfter${index}`, [])
        if (!afterElement[0]) return
        afterElement[0].style.width = (this.widthTable + this.scrollX - 4) + 'px'
      })
    },
    showRowActive (index) {
      if (this.editTable === false) {
        this.rowActive = index
      }
      const widthTable = _.get(this.$refs, 'bbTableScroll.$el.offsetWidth', 0)
      const afterElement = _.get(this.$refs, `bbRowAfter${index}`, [])
      const width = (widthTable !== 0 ? widthTable : this.widthTable) + this.scrollX
      if (!afterElement[0]) return
      if (afterElement[0].style.width === width + 'px') return
      if (width && afterElement[0]) {
        afterElement[0].style.width = width + 'px'
        afterElement[0].style.left = -4 + 'px'
      }
    },
    hideRowActive () {
      if (this.editTable === false) {
        this.rowActive = false
        this.deleteConfirmIndex = false
      }
    },
    dragChange (e) {
      const id = _.get(e.moved, 'element.id', '')
      const newIndex = _.get(e.moved, 'newIndex', '')
      const lastIndex = _.get(e.moved, 'oldIndex', '')
      const noMove = newIndex === lastIndex
      const lastColumn = this.columns[this.columns.length - 1]
      const setPosition = _.get(lastColumn, 'actions.setPosition', '')
      const newPosition = {
        id: id,
        newListLocation: newIndex
      }
      if (!id || !setPosition || noMove) return
      setPosition(newPosition)
    },
    dragStart (e) {
      this.dragging = true
      e.clone.style.backgroundColor = 'red'
      e.clone.classList.remove('bb-table-body-row_active')
      e.item.style.cssText = ''
    },
    dragEnd (e) {
      e.item.style.cssText = ''
      this.dragging = false
    },
    hideEditable (index) {
      if (this.editTable !== index) {
        this.editTable = false
        this.delNewRow()
      }
    },
    checkVisibleStatus (row, column) {
      if (_.isUndefined(column.visible)) return true
      return _.get(row, column.visible, false)
    },
    setDataFilter (data, item, section, list) {
      this.hideFilter()
      const findItem = _.find(list, item)
      const property = _.get(section, 'property', '')
      _.set(findItem, 'checked', data)
      section.actions.filter(data, item, property)
    },
    hideFilter () {
      this.stopHideFilter = true
      _.delay(() => {
        if (this.stopHideFilter) {
          this.openFilterPopup = false
        }
      }, 100)
    },
    updateScroll (e) {
      this.scrollX = e.target.scrollLeft
      this.setWidthActiveRow()
    },
    clickThead (column) {
      const getRequest = _.get(column, 'get', false)
      if (!column.sort || !getRequest) return
      if (column.property === this.filterByColumn) {
        this.filterByColumn = column.property + '&sort[]=-1'
      } else {
        this.filterByColumn = column.property
      }
      getRequest({query: 'sort[]=' + this.filterByColumn})
    },
    checkTriple (column) {
      const upload = column.toolbar ? column.toolbar.upload : false
      const fund = column.typeTable === 'funds'
      return upload || fund
    },
    setDate (date, obj) {
      const row = obj.row
      const column = obj.column
      const idFind = column.typeTable === 'kpiInfo' ? {_id: row._id} : {id: row.id}
      let index = _.findIndex(this.copyRows, idFind)
      if (row.newMode) {
        index = _.findIndex(this.copyRows, 'newMode')
      }
      _.set(this.copyRows[index], column.property, date)
    },
    preventDefaults (e) {
      e.preventDefault()
      e.stopPropagation()
    },
    addEventsDrop () {
      this.leave.concat(this.enter).forEach(eventName => {
        document.body.addEventListener(eventName, this.preventDefaults)
      })
      this.enter.forEach(eventName => {
        document.body.addEventListener(eventName, this.dropFileEvent)
      })
      document.body.addEventListener('drop', this.dropEventCoordinate)
      document.body.addEventListener('dragleave', this.dragleave)
    },
    dropFileEvent () {
      this.dropFile = true
    },
    dropEventCoordinate (e) {
      let includeX = false
      if (this.editTable !== false && !this.statusUpload) {
        const row = this.$refs.row[this.editTable]
        if (row) {
          const coordinateRow = row.getBoundingClientRect()
          includeX = e.clientX >= coordinateRow.left && e.clientX <= coordinateRow.right
        }
      }
      if (includeX) {
        let dt = e.dataTransfer
        let files = dt.files
        const indexColumn = _.findIndex(this.columns, {toolbar: {upload: true}})
        this.uploadFile(files, {column: this.columns[indexColumn]})
      }
      this.dropFile = false
    },
    dragleave (e) {
      if (e.screenX === 0 || e.screenX > document.body.clientWidth || e.pageY >= document.body.clientHeight) {
        this.dropFile = false
      }
    },
    calcHeightTable () {
      const tableScroll = _.get(this.$refs, 'bbTableScroll.$el', '')
      if (!tableScroll) return
      if (this.autoHeight) {
        this.tableScroll = true
        return
      }
      const tableScrollCoordinates = tableScroll.getBoundingClientRect()
      const heightButton = 49
      const pagination = this.totalPages > 1 ? 67 : 0
      const maxHeight = document.body.clientHeight - tableScrollCoordinates.top - heightButton - 40 - pagination
      const minHeight = this.minHeight || 300
      const height = maxHeight < minHeight ? minHeight : maxHeight
      tableScroll.style.overflow = 'hidden'
      tableScroll.style.maxHeight = this.heightTable || height + 'px'
      const tableHeight = ((51 * this.rows.length) + 52)
      this.tableScroll = this.heightTable || tableHeight > height
    },
    scrollUp () {
      if (this.stopScrollUp) return
      const tableScroll = _.get(this.$refs, 'bbTableScroll.$el', {})
      tableScroll.scrollTop = 0
      const mainScroll = _.get(this.mainScroll, 'target', {})
      if (!tableScroll.offsetTop) return
      mainScroll.scrollTop = tableScroll.offsetTop - 58
    },
    async copyToClipboard(value) {
      await navigator.clipboard.writeText(value);
    },
  },
  watch: {
    rows (newVal, oldVal) {
      if (_.difference(newVal, oldVal).length) {
        this.hideRowActive()
        this.hideEditable()
      }
      if (this.rows.length === 0) {
        return
      }
      const indexNewRow = _.findIndex(this.rows, {newMode: true})
      if (indexNewRow !== -1 && this.rows[indexNewRow].newMode) {
        this.statusUpload = false
        this.editTable = indexNewRow
        this.newRow = true
      }
      this.scrollUp()
      this.copyRows = _.cloneDeep(this.rows)
      this.calcHeightTable()
      this.setWidthActiveRow()
    }
  },
  mounted () {
    const container = _.get(this.$refs, 'bbTableScroll.$el', '')
    if (container) this.preventBackOnHorizontalScroll(container)
    window.addEventListener('resize', this.calcHeight, false)
  },
  beforeMount () {
    this.addEventsDrop()
    this.copyRows = _.cloneDeep(this.rows)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcHeight, false)
    const events = [...this.leave, ...this.enter]
    document.body.removeEventListener('dragleave', this.dragleave)
    document.body.removeEventListener('drop', this.dropEventCoordinate)
    this.removeAllEventListener(document.body, events, this.preventDefaults)
    this.removeAllEventListener(document.body, this.enter, this.dropFileEvent)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-table-wrapper {
  position: relative;
  border-radius: 5px;
  box-shadow: 0 0 20px rgba($color-black, 0.05);
  width: 100%;

  &-input {
    display: inline-block;
    position: relative;

    &__error {
      white-space: nowrap;
      position: absolute;
      top: 8px;
      right: 5px;
      color: $color-red-orange;
      background-color: $color-white;
      font-size: 11px;
      line-height: 14px;
      z-index: 55;
      pointer-events: none;
    }
  }

  &_auto-height {
    height: 100%;
    overflow: hidden;
  }

  &-img {
    position: relative;
    border-radius: 50%;

    &__popup {
      pointer-events: none;
      height: 28px;
      opacity: 0;
      position: absolute;
      transform: translate(0, 125%);
      padding: 4px 7px;
      color: $color-white;
      font-size: 11px;
      text-transform: capitalize;
      white-space: nowrap;
      background: rgba($color-black, 0.55);
      border-radius: 4px;
      z-index: 99999;
      transition: 0.2s;

      &:after {
        content: '';
        position: absolute;
        left: calc(50% - 3px);
        bottom: 100%;
        width: 0;
        height: 0;
        border-left: 3px solid transparent;
        border-right: 3px solid transparent;
        border-bottom: 5px solid rgba($color-black, 0.55);
      }

      &_logs {
        opacity: 1;
      }
    }
  }

  &__item {
    background: $color-white;
  }

  &-info {
    display: flex;

    &_logs {
      min-width: 0;
      width: 100%;

      div {
        min-width: 0;
      }
    }

    &__icon-wrapper {
      position: relative;
    }

    &__icon {
      font-size: 14px;
      color: $color-silver-chalice;
      margin-left: 13px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        opacity: 0.7;
      }
    }

    &__popup {
      position: absolute;
      white-space: nowrap;
      top: -44px;
      left: 8px;

      &_logs {
        left: auto;
        right: -4px;
        top: 30px;
        width: 300px;
        white-space: normal;
      }
    }
  }

  &_modal {
    box-shadow: none;
    padding: 0 0 1px;
    margin-bottom: 0;
    margin-top: 0;
    max-height: 70vh;
    overflow: hidden;
  }

  &-drop-file {
    position: absolute;
    left: 0;
    height: 51px;
    width: 100%;
    z-index: 99;
    user-select: none;
    cursor: pointer;
    overflow: hidden;

    &__background {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      backdrop-filter: blur(4px);
      background: rgba($color-white, 0.85);
      border-radius: 5px;
    }

    &-title {
      position: absolute;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: $color-accent;
      border: 1px dashed $color-accent;
      box-sizing: border-box;
      border-radius: 5px;

      &__text {
        font-weight: 600;
        font-size: 12px;
        line-height: 14px;
      }

      &__icon {
        margin-right: 7px;
        font-size: 18px;
      }

      &__input {
        position: absolute;
        left: 0;
        padding: 100% 100% 0 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
  }

  &_no-scroll {
    overflow: visible !important;
    height: 100%;
    max-height: 100%;
  }
}

.bb-table-body__item__copied {
  position: relative;
}

.bb-table-body__item-copyCell {
  position: relative;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bb-table-body__item-copy-icon {
  position: absolute;
  right: 5px;
  top: 0;
  cursor: pointer;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  overflow: hidden;

  img {
    max-width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/Table/Table.vue